import { memo, useCallback } from 'react';

import { Check, Copy } from '@air/next-icons';
import { Button } from '@air/primitive-button';
import { cn } from '@air/utils-tailwind';

import { COPY_URL_BUTTON } from '~/constants/testIDs';
import { useCopyLinkToClipboard } from '~/hooks/useCopyLinkToClipboard';

type CopyLinkButtonProps = {
  onCopied: (url: string) => void;
  shareUrl: string;
  className?: string;
};

export const CopyLinkButton = memo(({ onCopied, shareUrl, className }: CopyLinkButtonProps) => {
  const { copyLinkToClipboard, copied } = useCopyLinkToClipboard();

  const onClick = useCallback(() => {
    copyLinkToClipboard(shareUrl, onCopied);
  }, [copyLinkToClipboard, shareUrl, onCopied]);

  return (
    <Button
      data-testid={COPY_URL_BUTTON}
      appearance="filled"
      color="blue"
      onClick={onClick}
      size="extra-large"
      className={cn('gap-1', className)}
      prefix={copied ? <Check className="size-6" /> : <Copy className="size-6" />}
    >
      {copied ? 'Link copied' : 'Copy link'}
    </Button>
  );
});

CopyLinkButton.displayName = 'CopyLinkButton';
